import type { entryResource } from '@porotutu/api/features/adm/audit/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { adm } from '@/api/client'
import { AUDIT } from '@/api/keys'
import type { Action, AuditKind, AuditSort } from '../vocabulary'

export type Entry = ReturnType<typeof entryResource>

export type EntryPage = { data: Entry[]; meta: ListMeta }

export type AuditListQuery = ListQuery<AuditSort, never> & {
  kind?: AuditKind
  action?: Action
  subject_id?: string
}

export const entriesQuery = (query: AuditListQuery) =>
  queryOptions({
    queryKey: [...AUDIT, 'list', query] as const,
    queryFn: async () => unwrap(await adm.audit.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const entryQuery = (id: string) =>
  queryOptions({
    queryKey: [...AUDIT, 'record', id] as const,
    queryFn: async () => unwrap(await adm.audit({ id }).get()),
    staleTime: Number.POSITIVE_INFINITY,
  })

export const exportHref = exportHrefFor<AuditListQuery>('/api/v1/adm/audit/export', {
  always: [],
  viewed: ['search', 'kind', 'action', 'subject_id'],
})
